import { render, staticRenderFns } from "./Peppy.vue?vue&type=template&id=fc288eba&scoped=true"
import script from "./Peppy.vue?vue&type=script&lang=js"
export * from "./Peppy.vue?vue&type=script&lang=js"
import style0 from "./Peppy.vue?vue&type=style&index=0&id=fc288eba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc288eba",
  null
  
)

export default component.exports